import { TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

export function SurnameField() {
  const { formatMessage } = useIntl();

  return (
    <TextFieldElement
      name="surname"
      label={formatMessage({
        id: 'admin.users.form.surname.label',
        defaultMessage: 'Apellido',
      })}
      fullWidth
    />
  );
}
